import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-flex;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./components/_common/InlineEditableField/Wrapper.js